import { Controller } from "@hotwired/stimulus"
import Plotly from "plotly.js-dist-min"

export default class extends Controller {
  static values = {
    data: Array,
    type: String,
    title: String
  }

  connect() {
    this.renderChart()
  }

  renderChart() {
    if (this.typeValue === 'line') {
      this.renderLineChart()
    } else if (this.typeValue === 'funnel') {
      this.renderFunnelChart()
    }
  }

  renderLineChart() {
    const trace = {
      x: this.dataValue.map(d => d.period_label),
      y: this.dataValue.map(d => d.count),
      type: 'scatter',
      mode: 'lines+markers',
      marker: {
        color: '#7C3AED',
        size: 8
      },
      line: {
        color: '#7C3AED',
        width: 3
      }
    }

    const layout = {
      title: {
        text: this.titleValue,
        font: {
          size: 20,
          family: 'Neue Haas Grotesk Text Pro, sans-serif'
        }
      },
      xaxis: {
        title: 'Period',
        tickangle: -45
      },
      yaxis: {
        title: 'Number of Claims'
      },
      margin: {
        l: 60,
        r: 30,
        t: 80,
        b: 100
      },
      hovermode: 'closest'
    }

    const config = {
      responsive: true,
      displayModeBar: true,
      displaylogo: false,
      modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d', 'autoScale2d']
    }

    Plotly.newPlot(this.element, [trace], layout, config)
  }

  renderFunnelChart() {
    const trace = {
      type: 'funnel',
      y: this.dataValue.map(d => d.label),
      x: this.dataValue.map(d => d.value),
      textposition: 'inside',
      textinfo: 'value+percent initial',
      marker: {
        color: this.dataValue.map(d => d.color)
      },
      connector: {
        line: {
          color: '#E5E7EB',
          width: 2
        }
      }
    }

    const layout = {
      title: {
        text: this.titleValue,
        font: {
          size: 20,
          family: 'Neue Haas Grotesk Text Pro, sans-serif'
        }
      },
      margin: {
        l: 200,
        r: 30,
        t: 80,
        b: 30
      }
    }

    const config = {
      responsive: true,
      displayModeBar: true,
      displaylogo: false,
      modeBarButtonsToRemove: ['pan2d', 'lasso2d', 'select2d', 'autoScale2d']
    }

    Plotly.newPlot(this.element, [trace], layout, config)
  }
}
